import {Component, Inject, OnInit} from '@angular/core';
import {Interlignage, PoliceNames, style, ThemesNames} from "../../common/models/style.model";
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {StyleService} from "../../common/services/style.service";

@Component({
  selector: 'app-theme-choice',
  templateUrl: './theme-choice.component.html',
  styleUrls: ['./theme-choice.component.scss']
})
export class ThemeChoiceComponent implements OnInit {
  mainStyle: style = <style>{};
  themesNames = ThemesNames;
  themeChoiceForm: UntypedFormGroup;
  interlignage: Interlignage = Interlignage.default;
  police: PoliceNames = PoliceNames.default;

  constructor(@Inject(MAT_DIALOG_DATA) public data: {mainStyle: style, interlignage: Interlignage, police: PoliceNames},
              public dialogRef: MatDialogRef<ThemeChoiceComponent>,
              private styleService: StyleService,
              private formBuilder: UntypedFormBuilder,) { }

  ngOnInit(): void {
    this.mainStyle = this.data.mainStyle;
    this.interlignage = this.data.interlignage;
    this.police = this.data.police;
    this._initForm();
  }

  getThemeName(themeName: string): string{
    return this.styleService.getThemeName(themeName);
  }

  setTheme(themeName: ThemesNames): void {
    this.styleService.updateMainBGColor(themeName);
    this.styleService.mainStyle$.subscribe((_mainStyle)=> {
      this.mainStyle = _mainStyle;
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private _initForm(): void {
    this.themeChoiceForm = this.formBuilder.group({
      theme: [this.mainStyle.themeName, []],
    });
  }



}
